'use client'

import SearchNav from './header-search-nav'
import { useAutocompleteAction } from './use-autocomplete-action'

const SearchNavApp = ({ triggerInputFocus }: { triggerInputFocus?: boolean }) => {
  return <SearchNav triggerInputFocus={triggerInputFocus} useAutocomplete={useAutocompleteAction} />
}

export default SearchNavApp
